var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.tryCancel } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                  _vm.isEdit
                    ? _c("BjLogButton", {
                        attrs: {
                          id: _vm.recordId,
                          "no-permission": "",
                          title: _vm.form.realName,
                          api: "roleApi",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            _vm._s(_vm.$t("AccountManagementAdd.customerInfo.titile")) + " "
          ),
        ]
      ),
      _c(
        "el-form",
        {
          ref: "queryForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "150px",
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.account"),
                        prop: "loginName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: 20,
                          disabled: _vm.isEdit,
                          placeholder: _vm.$t("AccountManagementAdd.place"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.loginName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "loginName", $$v)
                          },
                          expression: "form.loginName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.name"),
                        prop: "realName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.realName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "realName", $$v)
                          },
                          expression: "form.realName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("BjFormItemMobile", {
                    attrs: {
                      prop: "phone",
                      maxlength: 20,
                      label: _vm.$t("AccountManagementAdd.phone"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.email"),
                        prop: "email",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.isEdit
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AccountManagementAdd.password"),
                            prop: "password",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              disabled: _vm.isEdit,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.from"),
                        prop: "startDateActive",
                      },
                    },
                    [
                      _c("BjDatePicker", {
                        model: {
                          value: _vm.form.startDateActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startDateActive", $$v)
                          },
                          expression: "form.startDateActive",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.until"),
                        prop: "endDateActive",
                      },
                    },
                    [
                      _c("BjDatePicker", {
                        model: {
                          value: _vm.form.endDateActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endDateActive", $$v)
                          },
                          expression: "form.endDateActive",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", { attrs: { "right-fixed": "" } }, [
            _vm._v(_vm._s(_vm.$t("AccountManagementAdd.customerInfo.titile2"))),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.clientCode"
                        ),
                        prop: "customerInfo.clientCode",
                      },
                    },
                    [
                      _c("BjInputCode", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.clientCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "clientCode", $$v)
                          },
                          expression: "form.customerInfo.clientCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.bpCode"
                        ),
                        prop: "customerInfo.bpCode",
                      },
                    },
                    [
                      _c("BjInputCode", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.bpCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "bpCode", $$v)
                          },
                          expression: "form.customerInfo.bpCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CSGSales"
                        ),
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.csgSalesList,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.customerInfo.csgSales,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "csgSales", $$v)
                          },
                          expression: "form.customerInfo.csgSales",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CSGCustomerService"
                        ),
                        prop: "csgCustomer",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.customerNameList,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.customerInfo.csgCustomer,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "csgCustomer", $$v)
                          },
                          expression: "form.customerInfo.csgCustomer",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CustomerType"
                        ),
                        prop: "customerInfo.customerType",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.CustomerType"
                          ),
                          "option-list": _vm.USER_CUSTOMER_TYPE_LIST,
                        },
                        model: {
                          value: _vm.form.customerInfo.customerType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "customerType", $$v)
                          },
                          expression: "form.customerInfo.customerType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.ContactPerson"
                        ),
                        prop: "customerInfo.contactPerson",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.contactPerson,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "contactPerson",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.contactPerson",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.ContactPhoneNumber"
                        ),
                        prop: "customerInfo.billingAddressPhone",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.billingAddressPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "billingAddressPhone",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.billingAddressPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.industry"
                        ),
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.industryList,
                          placeholder: _vm.$t(
                            "AccountManagementAdd.customerInfo.industry"
                          ),
                        },
                        model: {
                          value: _vm.form.customerInfo.industry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "industry", $$v)
                          },
                          expression: "form.customerInfo.industry",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(
              _vm._s(
                _vm.$t("AccountManagementAdd.customerInfo.CompanyInformation")
              )
            ),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CompanyName"
                        ),
                        prop: "customerInfo.companyName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.companyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "companyName", $$v)
                          },
                          expression: "form.customerInfo.companyName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.customerInfo.abn"),
                        prop: "customerInfo.auBusinessNumber",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.auBusinessNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "auBusinessNumber",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.auBusinessNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.weburl"
                        ),
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.companyWebsite,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "companyWebsite",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.companyWebsite",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.GeneralEmail"
                        ),
                        prop: "customerInfo.generalEmail",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.generalEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "generalEmail", $$v)
                          },
                          expression: "form.customerInfo.generalEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.BillEmail"
                        ),
                        prop: "customerInfo.billingAddressEmail",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.billingAddressEmail,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "billingAddressEmail",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.billingAddressEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CustomerServiceEmail"
                        ),
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.customerEmail,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "customerEmail",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.customerEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CompanyAddress"
                        ),
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.billingAddress2,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "billingAddress2",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.billingAddress2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.generalEmailOther"
                        ),
                        prop: "customerInfo.generalEmailOther",
                      },
                    },
                    [
                      _c("BjTextarea", {
                        attrs: {
                          rows: 2,
                          maxlength: _vm.MAX_LENGTH.PRIORITY,
                          placeholder: _vm.$t("AccountManagementAdd.tips"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.generalEmailOther,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "generalEmailOther",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.generalEmailOther",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.BillEmailOther"
                        ),
                        prop: "customerInfo.billingAddressEmailOther",
                      },
                    },
                    [
                      _c("BjTextarea", {
                        attrs: {
                          rows: 2,
                          maxlength: _vm.MAX_LENGTH.PRIORITY,
                          placeholder: _vm.$t("AccountManagementAdd.tips"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.billingAddressEmailOther,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "billingAddressEmailOther",
                              $$v
                            )
                          },
                          expression:
                            "form.customerInfo.billingAddressEmailOther",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CustomerServiceEmailOther"
                        ),
                        prop: "customerInfo.customerEmailOther",
                      },
                    },
                    [
                      _c("BjTextarea", {
                        attrs: {
                          rows: 2,
                          maxlength: _vm.MAX_LENGTH.PRIORITY,
                          placeholder: _vm.$t("AccountManagementAdd.tips"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.customerEmailOther,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "customerEmailOther",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.customerEmailOther",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(
              _vm._s(
                _vm.$t("AccountManagementAdd.customerInfo.billingInformation")
              )
            ),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.AccountingPeriod"
                        ),
                        prop: "customerInfo.paymentTerm",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.$route.query.pageType != "canEdit",
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.paymentTerm,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "paymentTerm", $$v)
                          },
                          expression: "form.customerInfo.paymentTerm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.CreditLimit"
                        ),
                        prop: "customerInfo.creditLimit",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.$route.query.pageType != "canEdit",
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.creditLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "creditLimit", $$v)
                          },
                          expression: "form.customerInfo.creditLimit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.isNom"
                        ),
                        prop: "customerInfo.isNom",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.NOM_LIST },
                        model: {
                          value: _vm.form.customerInfo.isNom,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "isNom", $$v)
                          },
                          expression: "form.customerInfo.isNom",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.ifLocal"
                        ),
                        prop: "customerInfo.ifLocal",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.STATUS_YES_TRUE },
                        model: {
                          value: _vm.form.customerInfo.ifLocal,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "ifLocal", $$v)
                          },
                          expression: "form.customerInfo.ifLocal",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.currencySymbol"
                        ),
                        prop: "customerInfo.currencySymbol",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "lov-code": "CHANNEL_CURRENCY" },
                        model: {
                          value: _vm.form.customerInfo.currencySymbol,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "currencySymbol",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.currencySymbol",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.billingAddress"
                        ),
                        prop: "customerInfo.billingAddress1",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.billingAddress1,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "billingAddress1",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.billingAddress1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.palletAccount"
                        ),
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.palletAccount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.customerInfo,
                              "palletAccount",
                              $$v
                            )
                          },
                          expression: "form.customerInfo.palletAccount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountManagementAdd.customerInfo.deposit"
                        ),
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.customerInfo.deposit,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.customerInfo, "deposit", $$v)
                          },
                          expression: "form.customerInfo.deposit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("AccountManagementAdd.Role")))]),
      _c(
        "el-row",
        { staticClass: "mb8", attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "delete-btn",
                  attrs: {
                    type: "danger",
                    icon: "el-icon-delete",
                    disabled: _vm.multiple,
                  },
                  on: { click: _vm.onDeleteSelected },
                },
                [_vm._v(_vm._s(_vm.$t("delText")))]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                [_vm._v(_vm._s(_vm.$t("AccountManagementAdd.Add")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.roleTableData },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.RoleName"),
              align: "center",
              prop: "name",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.TenantName"),
              align: "center",
              prop: "tenantName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.from"),
              align: "center",
              prop: "name",
              width: "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjDatePicker", {
                      model: {
                        value: scope.row.startDateActive,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "startDateActive", $$v)
                        },
                        expression: "scope.row.startDateActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.until"),
              align: "center",
              prop: "name",
              width: "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjDatePicker", {
                      model: {
                        value: scope.row.endDateActive,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "endDateActive", $$v)
                        },
                        expression: "scope.row.endDateActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.size,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "size", $event)
          },
        },
      }),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          config: _vm.dialogListConfig,
          disabled: _vm.disabledIds,
          multiple: "",
        },
        on: { confirm: _vm.onConfirmDialogList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }